export default {
    branches: (state) => state.filters.branches.content,
    healthcareProviders: (state) => state.filters.healthcareProviders.content,
    rips: (state) => state.rips.body,
    loadingRIPS: (state) => state.rips.loading,
    ripsError: (state) => state.rips.errorAlert,
    filtersKeep: (state) => state.filtersKeep,
    loadingFilesDownload: (state) => state.files.loading,
    filesDownloadError: (state) => state.files.errorAlert,
}